import React, {useRef, useCallback } from "react";
import Quiz from "components/quizData/quiz";
import NavbarQuiz from "components/navbarQuiz/navbarQuiz";
import { useQuizState } from "utils/hooks/useQuizState";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";

export default function Quizs() {
  const {
    quizData,
    loading,
    error,
    searchTerm,
    setSearchTerm,
    hasMore,
    loadMore,
    refreshQuizzes
  } = useQuizState();

  const observer = useRef();
  const lastQuizElementRef = useCallback(node => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        loadMore();
      }
    });
    if (node) observer.current.observe(node);
  }, [loading, hasMore, loadMore]);

  const handleSearch = ({ searchTerm: newSearchTerm }) => {
    setSearchTerm(newSearchTerm);
  };

  if (error) {
    return (
      <div className="quiz-page">
        <div className="error-container">
          <div className="error-message">
            <p>{error}</p>
            <button 
              onClick={refreshQuizzes}
              className="retry-button"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-page">
      <div className="quizContainer">
        <NavbarQuiz onSearch={handleSearch} />
        
        <div className="quizContiners">
          {loading && quizData.length === 0 ? (
            <LoadingSpinner size="large" text="Loading quizzes..." />
          ) : quizData.length > 0 ? (
            quizData.map((quiz, index) => (
              <div
                key={quiz.id}
                ref={index === quizData.length - 1 ? lastQuizElementRef : null}
                className="quiz-card"
              >
                <Quiz
                  title={quiz.title}
                  id={quiz.id}
                  description={quiz.description}
                />
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>
                No quizzes found
                {searchTerm ? ` matching "${searchTerm}"` : ''}.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}